module.exports = __webpack_public_path__ + "img/imageLandingPreviewCaptureIcon.107858c5.svg";